module.exports = __webpack_public_path__ + "assets/img/download.c44483a6.png";